module.exports = __webpack_public_path__ + "static/media/no_image_user_kid_2.c36c1f16.png";